<template>
  <div class="yxtbiz-ai-training-design-list">
    <div class="flex-end mb16">
      <yxt-button
        type="primary"
        v-loading.fullscreen.lock="fullscreenLoading"
        class="pull-right"
        @click="importModel()"
      >
        导入模型
      </yxt-button>
      <input
        class="yxt-upload__input"
        type="file"
        ref="input"
        @change="uploadAction"
        accept=".xls,.xlsx"
      />
    </div>
    <template v-if="!loading && tableData && tableData.length === 0">
      <yxt-empty empty-text="尚未生成过学习地图，请先导入人才岗位模型">
      </yxt-empty>
    </template>
    <template v-else>
      <yxt-table :data="tableData" v-loading="loading">
        <yxt-table-column
          label="学习地图"
          prop="name"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="color-primary-6 hand" @click="nameClick(scope.row.id)">
              {{ scope.row.learningMapName }}
            </div>
          </template>
        </yxt-table-column>
        <yxt-table-column
          label="创建时间"
          prop="createTime"
          :formatter="timeFormatter"
        ></yxt-table-column>
        <yxt-table-column
          label="创建人"
          prop="userName"
          min-width="90"
          show-overflow-tooltip
          :popover-html="true"
        >
          <template slot-scope="scope">
            <yxtbiz-user-name :name="scope.row.userName" />
          </template>
        </yxt-table-column>

        <yxt-table-column label="操作" width="100">
          <template slot-scope="scope">
            <yxt-button type="text" @click="deleteRow(scope.row.id)"
              >删除</yxt-button
            >
          </template>
        </yxt-table-column>
      </yxt-table>
      <div class="mt16">
        <yxt-pagination
          class="pull-right"
          :current-page.sync="page.current"
          :page-size="page.limit"
          simple-total
          layout="total, prev, pager, next"
          :total="page.count"
          @current-change="handelCurrentChange"
        ></yxt-pagination>
      </div>
    </template>
  </div>
</template>
<script>
import {
  learningMapPage,
  learningMapImport,
  deleteLearningMap
} from '../service';
import dateUtil from 'yxt-biz-pc/src/utils/date';
import { Table, TableColumn, Pagination, Tooltip } from 'yxt-pc';

export default {
  components: {
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtPagination: Pagination,
    YxtTooltip: Tooltip
  },
  props: {},
  data() {
    return {
      tableData: [],
      loading: true,
      fullscreenLoading: false,
      page: {
        limit: 10,
        current: 1,
        count: 0,
        offset: 0
      }
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        limit: this.page.limit,
        current: this.page.current
      };
      this.loading = true;
      learningMapPage(params)
        .then(res => {
          const data = res.datas || [];
          this.tableData = data;
          this.page.count = res.paging.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handelCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    search() {
      this.page.current = 1;
      this.getData();
    },

    timeFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return '--';
      }
      if (typeof cellValue === 'string') {
        cellValue = cellValue.replace(/-/g, '/');
      }
      return dateUtil.format(new Date(cellValue), 'yyyy-MM-dd HH:mm');
    },
    nameClick(id) {
      this.$emit('goDetail', id);
    },
    importModel() {
      this.$refs.input.value = null;
      this.$refs.input.click();
    },
    uploadAction(ev) {
      const files = ev.target.files;
      if (!files) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      this.fullscreenLoading = true;
      learningMapImport(formData)
        .then(res => {
          this.nameClick(res.id);
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    deleteRow(id) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteLearningMap(id)
            .then(() => {
              this.search();
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }
};
</script>